import logo from '../../assets/img/bmo-onguard-ida-logo-EN.svg';
import maintenanceLogo from '../../assets/img/logo-header-en-ca.svg';
import { ROUTE_PATH_CONTACT, SHOW_MAINTENANCE_PAGE } from '../../constants';
import { SiteHeaderTranslations } from '../types';

export const translations: SiteHeaderTranslations = {
  logoImage: {
    src: SHOW_MAINTENANCE_PAGE() ? maintenanceLogo : logo,
    alt: SHOW_MAINTENANCE_PAGE() ? 'OnGuard Logo' : 'OnGuard Powered by ID Assist logo',
    height: SHOW_MAINTENANCE_PAGE() ? 26 : 48,
    width: SHOW_MAINTENANCE_PAGE() ? 158 : 269
  },
  skipToMainContent: 'Skip to main content',
  skipToNavMenu: 'Skip to navigation menu',
  navMenu: {
    contact: {
      to: ROUTE_PATH_CONTACT,
      exact: true,
      children: 'Contact',

    },
    languageToggle: {
      to: '',
      children: 'Français'
    }
  }
};
